Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var vO425 = {
  prefix: "V",
  blacklist: ["prototype", "process", "require", "mainModule", "Module", "__compile", "constructor", "__defineGetter__", "__defineSetter__", "hasOwnProperty", "__lookupGetter__", "__lookupSetter__", "isPrototypeOf", "propertyIsEnumerable", "valueOf", "__proto__", "arguments", "caller", "constructor", "apply", "bind", "call"],
  maxLoop: 1000000,
  maxStack: 2000
};
exports.default = vO425;